import useSWR from 'swr'

import {LevelMap} from '../types'
import {getLevelMapList} from '../api/listApi'

export default function useItemTypes() {
  return useSWR<LevelMap[], Error>('level-map', getLevelMapList)
}
